
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  props: {
    Search: { type: String, default: '' },
    ParentThis: { type: Object as PropType<any> }
  },
  mounted () {
    this.ReadCookiesData()
    this.ChangeTableButtons(this.ParentThis, this.Buttons)
    this.ChangeFilter(this.ParentThis, this.Filter)
  },
  data () {
    return {
      Loading: [] as Array<string>,
      CookiesData: ''
    }
  },
  computed: {
    Filter () :FilterObject | undefined {
      return undefined
    },
    Buttons () :Array<FunctionalTableButton> {
      return []
    }
  },
  methods: {
    ReadCookiesData () {
      this.Loading.push('Loading') // Add Loading flag
      this.Get('Config', '?Name=Catalog_MainURL').then(response => {
        this.CookiesData = response[0]?.Value
        this.MEMWrite('Catalog_MainURL', response[0]?.Value)
        this.Loading.pop() // Remove Loading flag
      }, error => {
        this.Loading.pop() // Remove Loading flag
        error.CookiesError = 'Error in reading Catalogs'
        this.OpenDialog('Error_Dialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    SaveMyConfig (Config :string, Value :any) {
      this.SaveConfig(Config, Value)
    },
    CopyLink (Catalog :Catalog) {
      const elem = document.createElement('textarea')
      elem.value = location.origin + Catalog.CatalogLink
      document.body.appendChild(elem)
      elem.select()
      document.execCommand('copy')
      document.body.removeChild(elem)
      this.PushNotification('Link Copied')
    },
    OpenCatalog (Catalog :Catalog) {
      this.$router.push('/Catalogs/ViewCatalog/' + Catalog.ID)
    },
    DeleteCatalog (Catalog :Catalog) {
      if (!this.Access('Catalogue_Remove')) {
        return
      }
      this.OpenDialog('General_Accept_Dialog', 'Delete', { PostMethod: 'DELETE', PostAPI: 'Catalogs', AddQuery: '/' + Catalog.ID, Text: 'Are you sure you want to delete <strong>' + Catalog.Name + '</strong>', ButtonClass: 'BGRed', ButtonText: this.Translate('Delete') } as GeneralAcceptDialogData, {})
    },
    ButtonsFunctions (button :string) {
      switch (button) {
        case 'NewCatalog':
          if (this.CookiesData.length >= 20) {
            this.OpenDialog('General_Accept_Dialog', this.Translate('Limits Reached!'), { ButtonClass: 'D-None', ButtonStyle: 'display: none;', PostAPI: '', Icon: 'Close', Text: this.Translate('Sorry! you have reached yur catalogs limits (10/10)') })
          } else {
            this.OpenDialog('Catalog_Dialog', this.Translate('New Catalog'), {})
          }
          break
        case 'ViewCatalogs':
          this.$router.push('/catalog/all')
          break
        case 'EditCover':
          this.$router.push('/Catalogs/ViewCatalogs')
          break
        case 'SendWhats':
          if (this.$store.state.CookiesConfig.WhatsappStatus === 'true') {
            var message = {
              messaging_product: 'whatsapp',
              to: '',
              type: 'template',
              template: {
                name: 'viewsaedyecatalogs',
                language: {
                  code: 'en'
                },
                components: [
                  {
                    type: 'header',
                    parameters: [
                      {
                        type: 'image',
                        image: {
                          link: this.$store.state.CookiesConfig.HeroImage
                        }
                      }
                    ]
                  },
                  {
                    type: 'body',
                    parameters: [
                      {
                        type: 'text',
                        text: this.$store.state.CookiesConfig.WhatsappContact
                      }
                    ]
                  }
                ]
              }
            }
            this.OpenDialog('Integration_WhatsappMessage_Dialog', 'Send Message on WhatsApp', { Data: message, Title: 'All Catalogs' })
          } else {
            this.PushNotification(this.Translate('WhatsApp Integration not Verified!!'))
          }
          break
      }
    },
    SendWhatsapp (catalog :Catalog) {
      if (this.$store.state.CookiesConfig.WhatsappStatus === 'true') {
        var CatalogName = catalog.Name.trim().replace(/(\r\n|\n|\r)/gm, '').replace(/(\r\n|\n|\r)/, '').replaceAll('\r', '').replaceAll('\n', '').replaceAll('<br>', '').replaceAll('<br/>', '').trim()
        CatalogName = CatalogName.replace(/(\r\n|\n|\r)/gm, '<1br />')
        var re1 = /<1br \/><1br \/>/gi
        // var re1a = /<1br \/><1br \/><1br \/>/gi
        CatalogName = CatalogName.replace(re1, ' ')
        var re2 = /\\<1br \/>/gi
        CatalogName = CatalogName.replace(re2, ' ')
        var re3 = /\s+/g
        CatalogName = CatalogName.replace(re3, ' ')
        var re4 = /<2br \/>/gi
        CatalogName = CatalogName.replace(re4, '\n\n')
        var message = {
          messaging_product: 'whatsapp',
          to: '',
          type: 'template',
          template: {
            name: 'dynamic_catalog',
            language: {
              code: 'en'
            },
            components: [
              {
                type: 'header',
                parameters: [
                  {
                    type: 'image',
                    image: {
                      link: catalog?.ImgURL
                    }
                  }
                ]
              },
              {
                type: 'body',
                parameters: [
                  {
                    type: 'text',
                    text: CatalogName
                  },
                  {
                    type: 'text',
                    text: this.$store.state.CookiesConfig.WhatsappContact
                  }
                ]
              },
              {
                type: 'button',
                sub_type: 'URL',
                index: '0',
                parameters: [
                  {
                    type: 'payload',
                    payload: catalog?.Sequence
                  }
                ]
              }
            ]
          }
        }
        this.OpenDialog('Integration_WhatsappMessage_Dialog', 'Send Message on WhatsApp', { Data: message, Title: CatalogName })
      } else {
        this.PushNotification(this.Translate('WhatsApp Integration not Verified!!'))
      }
    }
  },
  watch: {
    CurrentDialogs: function (newVal, oldVal) { // watch it
      if (newVal < oldVal) {
        this.ReadCookiesData()
      }
    },
    Filter: function () { // watch it
      this.ChangeFilter(this.ParentThis, this.Filter)
    },
    Buttons: function () { // watch it
      this.ChangeTableButtons(this.ParentThis, this.Buttons)
    }
  }
})
